'use client'
import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

const CurrencySelectNotification: React.FC = () => {
  const t = useTranslations('translation')

  return (
    <div className={styles.container}>
      <Image width={20} height={20} src="/img/icons/info.svg" alt="info" />
      <div>{t('selectMethodDisclaimer')}</div>
    </div>
  )
}

export default CurrencySelectNotification
